/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_available = /** @type {(inputs: {}) => string} */ () => {
	return `Dostupné`
};

const da_available = /** @type {(inputs: {}) => string} */ () => {
	return `Tilgængelig`
};

const de_available = /** @type {(inputs: {}) => string} */ () => {
	return `Verfügbar`
};

const en_available = /** @type {(inputs: {}) => string} */ () => {
	return `Available`
};

const es_available = /** @type {(inputs: {}) => string} */ () => {
	return `Disponible`
};

const fr_available = /** @type {(inputs: {}) => string} */ () => {
	return `Disponible`
};

const hu_available = /** @type {(inputs: {}) => string} */ () => {
	return `Elérhető`
};

const it_available = /** @type {(inputs: {}) => string} */ () => {
	return `Disponibile`
};

const nl_available = /** @type {(inputs: {}) => string} */ () => {
	return `Beschikbaar`
};

const pl_available = /** @type {(inputs: {}) => string} */ () => {
	return `Dostępny`
};

const pt_available = /** @type {(inputs: {}) => string} */ () => {
	return `Disponível`
};

const sv_available = /** @type {(inputs: {}) => string} */ () => {
	return `Tillgänglig`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const available = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.available(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("available", locale)
	if (locale === "cs") return cs_available(inputs)
	if (locale === "da") return da_available(inputs)
	if (locale === "de") return de_available(inputs)
	if (locale === "en") return en_available(inputs)
	if (locale === "es") return es_available(inputs)
	if (locale === "fr") return fr_available(inputs)
	if (locale === "hu") return hu_available(inputs)
	if (locale === "it") return it_available(inputs)
	if (locale === "nl") return nl_available(inputs)
	if (locale === "pl") return pl_available(inputs)
	if (locale === "pt") return pt_available(inputs)
	return sv_available(inputs)
};